<template>
    <div class="StoreDetailsWrap">
        <div class="LineCut flexbetween">
            <div class="NewsTitle flexa"><p>云平台</p></div>
            <div class="Return flexa" @click="Return"><p>返回</p><img src="../../assets/Home/return.png"></div>
        </div>
        <div v-if="outflag" class="TabButton flex">
            <div v-for="(item,index) in TabButtonData" :key="index" class="flexa" :class="{Active:index==flag}" @click="Tab(index)">
                <img :src="item.Icon">
                <p>{{item.Text}}</p>
            </div>
        </div>
        <!-- 定制产品详情 -->
        <div class="CustomizationBox Scroll" v-if="customboxstate">
            <Customization
                    :flag="flag"
                    @CloseCustomBox="CloseCustomBox"
                    @OpenChooseBox="OpenChooseBox"
                    :customdetailsdata="customdetailsdata"
                    :choosedperson="choosedperson"
                    :classid="'MN037870000000000000000001'"
            ></Customization>
        </div>
        <!-- 产品详情页 -->
        <div class="ProductDetails" v-if="productboxstate">
            <Productdetails
                    :flag="flag"
                    :titlename="'云平台'"
                    :productdetailsdata="productdetailsdata"
                    @CloseProductBox="CloseProductBox"
                    :classid="'MN037870000000000000000001'"
            ></Productdetails>
        </div>
        <div v-if="outflag" class="TabContentWrap clearfix">
            <ul>
                <li v-for="(item,index) in ProductData" :key="index" @click="ToDetails(item.产品ID)">
                    <div class="IconWrap">
                        <img :src="item.logo图">
                        <div class="Name"><p>{{ item.名称 }}</p></div>
                        <div class="flexa Items"><span>{{ item.标签 }}</span></div>
                    </div>
                    <div class="TextWrap">
                        <p class="sixline">{{ item.详情介绍 }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
  import Productdetails from './ProductDetails';
  import Customization from '../../components/Customization';
  export default {
    name: 'storedetails',
    inject: [
      'load'
    ],
    components: {
      Productdetails,
      Customization
    },
    data() {
      return {
        flag: 0,
        outflag: true,
        customboxstate: false,
        productboxstate: false,
        choosestate: false,
        ProductData: [],
        choosedperson: {},
        customdetailsdata: {},
        productdetailsdata: {},
        TabButtonData: [
          {
            Icon: require('../../assets/Buttonicon/button1.png'),
            Text: '云平台'
          },
          {
            Icon: require('../../assets/Buttonicon/button2.png'),
            Text: '最新上架'
          },
          {
            Icon: require('../../assets/Buttonicon/button3.png'),
            Text: '定制服务'
          }
        ]
      };
    },
    created() {
      console.log(this.$route.params.flag);
      if (this.$route.params.flag) {
        this.flag = this.$route.params.flag;
      }
      if (this.$route.params.id) {
        this.flag = 0;
        this.outflag = false;
        this.ToDetails(this.$route.params.id);
      } else if (
        this.$route.params.flag === 0 ||
        this.$route.params.flag === undefined
      ) {
        this.GetProductList('WBA0007033');
      } else if (this.$route.params.flag === 2) {
        this.GetProductList('WBA0007035');
      } else {
        this.GetProductList('WBA0007034');
      }
    },
    methods: {
      OpenChooseBox() {
        this.GetPersonList();
      },
      CloseCustomBox() {
        this.customboxstate = false;
      },
      /* 获取定制详情 */
      GetCustomDetails(id) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007004',
            userId: 'CommonUser_ixuOYxkPy78=',
            filter: { 产品ID: id }
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.load.hide();
              this.customdetailsdata = res.data.data.DETAIL[0];
              this.customboxstate = true;
              this.choosedperson = {};
            } else {
              this.load.hide();
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      /* 获取附加功能 */
      GetMoreItemList(id) {
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007008',
            userId: 'CommonUser_ixuOYxkPy78=',
            filter: { 产品ID: id }
          }
        })
          .then(res => {
            this.load.hide();
            if (res.data.code === 0) {
              console.log(res);
              this.productdetailsdata.itemlist = res.data.data.DETAIL;
              /*     this.GetProductTime(id); */
              this.productboxstate = true;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.$message.error(error);
            this.load.hide();
            console.log(error);
          });
      },
      /* 获取商品详情 */
      GetProducDetails(id) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: 'WBA0007004',
            userId: 'CommonUser_ixuOYxkPy78=',
            filter: { 产品ID: id }
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.productdetailsdata.basedata = res.data.data.DETAIL[0];
              this.GetMoreItemList(id);
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      ToDetails(flag) {
        console.log('当前点击产品id', flag);
        if (this.flag === 0 || this.flag === 1) {
          this.GetProducDetails(flag);
        } else if (this.flag === 2) {
          this.GetCustomDetails(flag);
        }
      },
      CloseProductBox() {
        if (this.outflag) {
          this.productboxstate = false;
        } else {
          this.$router.back();
        }
      },
      /* 获取商品列表 */
      GetProductList(id) {
        this.load.show();
        this.$axios({
          method: 'POST',
          url: 'https://x6.goeasy.cn/cli/client/Web_GetCommandDatas',
          data: {
            commandId: id,
            userId: 'CommonUser_ixuOYxkPy78='
          }
        })
          .then(res => {
            if (res.data.code === 0) {
              console.log(res);
              this.ProductData = res.data.data.DETAIL;
            } else {
              this.$message.error(res.data.msg);
            }
            this.load.hide();
          })
          .catch(error => {
            this.load.hide();
            this.$message.error(error);
            console.log(error);
          });
      },
      Return() {
        this.$router.back();
      },
      Choose() {
        this.choosestate = !this.choosestate;
      },
      Tab(flag) {
        this.flag = flag;
        if (flag === 0) {
          this.GetProductList('WBA0007033');
        } else if (flag === 1) {
          this.GetProductList('WBA0007034');
        } else {
          this.GetProductList('WBA0007035');
        }
      }
    }
  };
</script>
<style scoped lang="scss">
    @import '../../../public/Value';
    .StoreDetailsWrap{
        width: 100%;
        position: relative;
        .ProductDetails,.CustomizationBox{
            width: 50%;
            height:calc(100% - 0.8rem);
            top:0.8rem;
            left: 25%;
            position: fixed;
            z-index: 4;
            background-color: #000;
            overflow-y: scroll;
            &::-webkit-scrollbar{
                display: none;
            }
        }
        .LineCut{
            width: 90%;
            margin: 0.05rem auto 0.05rem;
            border-bottom: 2px solid #fff;
            .Return{
                cursor: pointer;
                p{
                    font-size: $AdditionTextSize;
                    color: #fff;
                }
                img{
                    width: 0.05rem;
                    margin-left: 0.02rem;
                }
            }
            .NewsTitle{
                p{
                    font-size: $TitleSize;
                    color: #fff;
                    padding-bottom: 0.045rem;
                    span{
                        opacity: 0.6;
                        font-weight: normal;
                    }
                }
            }
        }
        .TabButton{
            width: 100%;
            height: 0.7rem;
            div{
                width: 0.82rem;
                height: 0.32rem;
                border-radius: 0.2rem;
                background-color: #cc3333;
                margin: 0 0.15rem;
                cursor: pointer;
                img{
                    width: 0.2rem;
                    margin:0 0.11rem 0 0.07rem;
                }
                p{
                    font-size: $TextSize;
                    color: #fff;
                }
            }
            div.Active{
                background-color: #cc6666;
            }
        }
        .TabContentWrap{
            width: 88%;
            margin: 0 auto;
            .Title {
                width: 100%;
                margin: 0 auto;
                position: relative;
                height: 0.3rem;
                margin-top: 0.1rem;
                p {
                    font-size: $TitleSize;
                    color: #fff;
                    position: absolute;
                    left: 0;
                    font-weight: bold;
                }
                i {
                    width: 0.1rem;
                    position: absolute;
                    right: 0;
                    cursor: pointer;
                    img {
                        width: 100%;
                    }
                }
            }
            ul{
                width: 100%;
                li{
                    width: 32%;
                    height: 1.3rem;
                    background-color: #fff;
                    border-radius: 0.1rem;
                    float: left;
                    margin-right: 2%;
                    margin-bottom: 2%;
                    position: relative;
                    cursor: pointer;
                    .Buttons{
                        width: 100%;
                        position: absolute;
                        bottom: 0.08rem;
                        left: 0;
                        div{
                            cursor: pointer;
                            p{
                                font-size: $AdditionTextSize;
                                color: #fff;
                            }
                        }
                        div:first-child{
                            width: 0.3rem;
                            height: 0.13rem;
                            border-radius: 0.4rem;
                            background-color: #8c73b5;
                            margin: 0 0.09rem;
                        }
                        div:last-child{
                            width: 0.48rem;
                            height: 0.13rem;
                            border-radius: 0.4rem;
                            background-color: #cc9933;
                        }
                    }
                    .TextWrap{
                        width: 82%;
                        margin: 0.1rem auto 0;
                        p{
                            font-size: $AdditionTextSize;
                            color: #414141;
                            line-height: 0.075rem;
                        }
                    }
                    .IconWrap{
                        margin: 0.1rem 0 0 0.1rem;
                        img{
                            width: 0.25rem;
                            border-radius: 0.05rem;
                        }
                        .Name{
                            margin: 0.03rem 0;
                            p{
                                font-size: $TextSize;
                                color: #000;
                                font-weight: bold;
                            }
                        }
                        .Items{
                            span{
                                font-size: $SmallTextSize;
                                color: #999999;
                                margin-right: 0.02rem;
                            }
                        }
                    }
                }
                li:nth-child(3n){
                    margin-right: 0;
                }
            }
        }
    }
</style>
